import { Card } from 'primereact/card'
import React, { useRef, useEffect, useState } from 'react'
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { useDispatch } from 'react-redux';
import { fetchdata, addfeeddata } from '../reduxactions/organizationactions/OrgAddFeedbackActions';
import { useSelector } from 'react-redux';
import { RootState } from '../reducers';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Toast } from 'primereact/toast';
import { Message } from 'primereact/message';
import { useNavigate } from 'react-router-dom';
import { Panel } from 'primereact/panel';
import { GFNButton } from '../ui';
import { InputTextarea } from 'primereact/inputtextarea';

const OrgAddFeedbacks = () => {
    const uid = window.sessionStorage.getItem('uid');
    const [globalFilter, setGlobalFilter] = useState('');

    const feedoptions = [
        { labels: 'Fundmanager', value: 'fundmanager' },
        { labels: 'Donor', value: 'donor' },
    ];

    const feedlist = [

        { "feedbacktypes": "excellent", "feedback": "Excellent" },
        { "feedbacktypes": "verygood", "feedback": "Very Good" },
        { "feedbacktypes": "good", "feedback": "Good" },
        { "feedbacktypes": "average", "feedback": "Average" },
        { "feedbacktypes": "poor", "feedback": "Poor" }

    ]

    const dispatch = useDispatch()

    const [nameId, setNameId] = useState('fundmanager');
    useEffect(() => {
        if (nameId !== '') {
            selectName();
        }
    }, [nameId]);

    const selectName = async () => {
        console.log("nameId:", nameId)
        try {
            await dispatch(fetchdata(uid, nameId) as any);
        } catch (error) {
            console.error('Error fetching data', error)
        }
    }

    const [acceptfield, setfield] = useState(false);
    const cancelfield = () => {
        setfield(false);
    }

    const viewupload = (rowData: any) => {

        assignData.current = { id: rowData.id }

        setfield(true);
    };
    const assignData = useRef({ id: '' })


    const [feedbacktype, setSelectedfeed] = useState('');
    const [description, setDesc] = useState('')
    const datas = useSelector((state: RootState) => state.orgaddfeed.data)
    const datasmsg = useSelector((state: RootState) => state.orgaddfeed.dataview)
    const toast = useRef(datasmsg);


    const navigate = useNavigate();

    const save = async () => {
        try {
            const { id } = assignData.current;

            await dispatch(addfeeddata(uid, nameId, description, feedbacktype, id) as any);
            toast.current.show({ severity: 'success', summary: 'Success', detail: datasmsg, life: 3000 })
            setfield(false);

        } catch (error) {
        }
        setTimeout(() => {
            const url = `/ofeedback`;
            navigate(url);
        }, 2000);

    }
    //for help
    const [openHelp, setHelp] = useState(false);
    const url1 = window.sessionStorage.getItem("apiRoot");
    const IUrl = `${url1}/help/org-Addfeedbacks.php`;
    const helpImg = `${url1}/help/help3.png`;
    const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
        event.preventDefault();
        const newWindowReference = window.open(
            targetUrl,
            'newwindow',
            'width=1000,height=1000,noopener,noreferrer'
        );

        if (newWindowReference) {
            newWindowReference.opener = null;
        }
    };
    return (
        <div className="admin-layout-container">
            <div className="row">
                <div className="main-content">
                    <div className="content-wrapper">
                        <section className="app-page-header">
                            <div>
                                <h1 className="app-page-title">Add Feedback</h1>
                            </div>
                            <a title="help" onClick={(e) => openWindow(e, IUrl)} className="app-help-link">
                                Help for this Page
                                <i className="pi pi-question-circle"></i>
                            </a>
                        </section>
                        <Panel>
                            <div className='grid'>
                                <div className='col-12'>
                                    <div className='col-4'>
                                        <h3 >Type</h3>
                                    </div>
                                    <div className='col-4'>
                                        <div className="card">
                                            <span className="p-float-label">
                                                <Dropdown optionValue="value" data-testid="type-select" value={nameId} className="w-full mb-3" onChange={(e) => { setNameId(e.value); selectName(); }} options={feedoptions} optionLabel="labels" placeholder="Select Type of Role" />
                                            </span>
                                        </div>
                                    </div>
                                    <div className="card flex flex-wrap justify-content-end my-2">
                                        <span className="p-input-icon-left">
                                            <i className="pi pi-search ml-2" />

                                            <InputText
                                                className="app-search-input"
                                                value={globalFilter}
                                                onChange={(e) => setGlobalFilter(e.target.value)}
                                                placeholder="Global Search"
                                            />
                                        </span>
                                    </div>

                                    <DataTable value={datas} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} >
                                        <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                                        <Column field="name" sortable header="Name"></Column>
                                        <Column field="email" sortable header="Email"></Column>
                                        <Column field="mobile" sortable header="Phone No."></Column>
                                        <Column header="Option" body={(rowData, { rowIndex }) => (
                                            <div>
                                                {/* <Button className='mr-1' severity="info" data-testid={`add-btn-${rowIndex}`} icon="pi pi-plus" rounded outlined onClick={() => viewupload(rowData)} /> */}
                                                <GFNButton className='mr-1' buttonType="secondary" data-testid={`add-btn-${rowIndex}`} icon="pi pi-plus" rounded onClick={() => viewupload(rowData)} />

                                            </div>
                                        )}></Column>
                                    </DataTable>

                                </div>
                            </div>
                        </Panel>
                        <Dialog
                            header="Add Feedback"
                            style={{ width: "35vw" }}
                            breakpoints={{ "960px": "60vw", "640px": "95vw" }}
                            data-testid="add-feedback-dialog"
                            visible={acceptfield}
                            onHide={cancelfield}
                            className="border-round-3xl"
                        >

                            <div className="p-3">

                                {/* Header Section */}
                                <div className="flex align-items-center mb-4">

                                    <div
                                        className="flex align-items-center justify-content-center border-circle shadow-2"
                                        style={{
                                            width: "65px",
                                            height: "65px",
                                            background: "#e0f2fe"
                                        }}
                                    >
                                        <i className="pi pi-comments text-3xl text-blue-500"></i>
                                    </div>

                                    <div className="ml-3">
                                        <h2 className="m-0 text-900">
                                            Feedback Details
                                        </h2>

                                        <p className="m-0 text-600">
                                            Share your valuable feedback
                                        </p>
                                    </div>

                                </div>

                                {/* Form Card */}
                                <div className="surface-50 border-1 border-200 border-round-2xl p-4">

                                    {/* Feedback Type */}
                                    <div className="field mb-4">

                                        <label
                                            htmlFor="feedbacktype"
                                            className="block text-800 font-semibold mb-2"
                                        >
                                            Feedback Type
                                        </label>

                                        <Dropdown
                                            optionValue="feedbacktypes"
                                            value={feedbacktype}
                                            data-testid="add-feedback-input"
                                            onChange={(e) => setSelectedfeed(e.value)}
                                            options={feedlist}
                                            optionLabel="feedback"
                                            placeholder="Select Feedback Type"
                                            className="w-full"
                                        />

                                    </div>

                                    {/* Description */}
                                    <div className="field">

                                        <label
                                            htmlFor="description"
                                            className="block text-800 font-semibold mb-2"
                                        >
                                            Description
                                        </label>

                                        <InputTextarea
                                            id="description"
                                            rows={5}
                                            autoResize
                                            className="w-full"
                                            data-testid="add-desc-input"
                                            name="description"
                                            placeholder="Enter your feedback description..."
                                            onChange={(e) => setDesc(e.target.value)}
                                        />

                                    </div>

                                </div>

                                {/* Footer Buttons */}
                                <div className="flex justify-content-end gap-2 mt-4">

                                    <Button
                                        label="Close"
                                        icon="pi pi-times"
                                        onClick={cancelfield}
                                        data-testid="add-close-btn"
                                        className="p-button-secondary"
                                    />

                                    <Button
                                        severity="info"
                                        label="Save"
                                        icon="pi pi-check"
                                        onClick={save}
                                        data-testid="add-save-btn"
                                        className="p-button-raised"
                                    />

                                </div>

                            </div>

                        </Dialog>
                        <Toast ref={toast} >
                            <Message severity="success" content={datasmsg} />
                        </Toast>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default OrgAddFeedbacks
